import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux';

export default () => compose(
  connect(
    (state) => ({
      currentLang: state.intl.locale || state.intl.currentLang
    })
  )
)



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/utils/withElementIntl.js